import { render, staticRenderFns } from "./StTokenSetting.vue?vue&type=template&id=79d8764d"
import script from "./StTokenSetting.vue?vue&type=script&lang=js"
export * from "./StTokenSetting.vue?vue&type=script&lang=js"
import style0 from "./StTokenSetting.vue?vue&type=style&index=0&id=79d8764d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports